export const getCharactersCount = (amount: number, max: number) =>
  `${amount}/${max}`;
